<template>
    <section class="practice">

        <vue-snotify></vue-snotify>
        <div>
            <b-modal id="modal-1" title="Assigned Focuses">
                <p>The Team Member that you are removing was assigned to:<span v-for="(focuse, index) in focuses"
                        :key="index">
                        <strong>{{ focusMap[focuse.FocusName] || focuse.FocusName }} </strong>
                    </span></p>
                <p>Please make a choice regarding your focus on <span v-for="(focuse, index) in focuses" :key="index">
                        <strong>{{ focusMap[focuse.FocusName] || focuse.FocusName }} </strong>
                    </span>:</p>

                <div class="radio-group">
                    <div v-for="(user, index) in users" :key="index">
                        <label v-if="user.UserID !== idToHide" class="radio-label">
                            <input type="radio" name="focus" :value="user.UserID" v-model="selectedUserId" />
                            {{ user.FirstName }} {{ user.LastName }} ({{ user.Status }})
                        </label>
                    </div>
                    <label class="radio-label">
                        <input type="radio" name="focus" />
                        I Will Choose Later
                    </label>
                </div>
                <template #modal-footer>
                    <b-button @click="proceedAction" variant="primary">Proceed</b-button>
                </template>
            </b-modal>


        </div>
        <div class="row">
            <aside class="col-md-3 col-sm-12 cus-sidebar">
                <practiceSidebar />
            </aside>
            <div v-if="isLoading" class="loader">
                <div class="wave-container">
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div>
                <p>Loading...</p>
            </div>
            <div v-if="!isLoading" id="content" class="content dailyReport view-dailyReport col-md-9 col-sm-12">
                <div class="material-box bg-white">
                    <div class="col-md-12 top-title">
                        <h3>View User</h3>
                    </div>
                    <div class="col-md-12">
                        <div class="section-container section-with-top-border p-b-10">
                            <div class="">
                                <!-- begin panel -->
                                <div class="panel" style="box-shadow: none; border: none;">
                                    <div class="table-responsive">
                                        <table
                                            class="table table-bordered table-hover table-striped table-td-valign-middle comnTbl">
                                            <thead>
                                                <tr class="bg-drk-blue">
                                                    <th class="text-center">Status</th>
                                                    <th class="text-center">Name</th>
                                                    <th class="text-center">Image</th>
                                                    <!--                                            <th class="text-center">Practice Name</th>-->
                                                    <th class="text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(user, index) in users" :key="index">
                                                    <td class="text-center">{{ user.Status }}</td>
                                                    <td class="text-center">{{ user.FirstName }} {{ user.LastName }}
                                                    </td>
                                                    <td class="text-center"><img :src="user.url" width="100"
                                                            class="rounded-corner" alt=""></td>
                                                    <td class="text-center">
                                                        <a @click.prevent="viewUser(user)"
                                                            class="btn btn-white my-1 btn-xs btn-rounded p-l-10 p-r-10">
                                                            <i class="fa fa-eye"></i> View
                                                        </a>
                                                        <a @click.prevent="editUser(user)"
                                                            class="btn btn-primary my-1 btn-blue btn-xs btn-rounded p-l-10 p-r-10">
                                                            <i class="fa fa-cog"></i> Edit
                                                        </a>
                                                        <a @click.prevent="removeUser(user.UserID)"
                                                            class="btn btn-danger my-1 btn-xs btn-rounded p-l-10 p-r-10">
                                                            <i class="fa fa-trash-o"></i> Remove
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <!-- end row -->
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 top-title">
                        <h3>Past Users</h3>
                    </div>
                    <div class="col-md-12">
                        <div class="section-container section-with-top-border p-b-10">
                            <div class="">
                                <!-- begin panel -->
                                <div class="panel" style="box-shadow: none; border: none;">
                                    <div class="table-responsive">
                                        <table
                                            class="table table-bordered table-hover table-striped table-td-valign-middle comnTbl">
                                            <tbody>
                                                <tr v-for="(past, i) in pastUsers" :key="i">
                                                    <td class="text-center">{{ dateFormat(past.RemoveDate) }}</td>
                                                    <td class="text-center">{{ past.Status }}</td>
                                                    <td class="text-center">{{ past.FirstName }} {{ past.LastName }}
                                                    </td>
                                                    <td class="text-center">
                                                        <a @click.prevent="viewUser(past)"
                                                            class="btn btn-white my-1 btn-xs btn-rounded p-l-10 p-r-10">
                                                            <i class="fa fa-eye"></i> View
                                                        </a>
                                                        <a @click.prevent="editUser(past)"
                                                            class="btn btn-primary my-1 btn-blue btn-xs btn-rounded p-l-10 p-r-10">
                                                            <i class="fa fa-cog"></i> Edit
                                                        </a>
                                                        <a @click.prevent="recoverUser(past.UserID)"
                                                            class="btn btn-danger my-1 btn-xs btn-rounded p-l-10 p-r-10"><i
                                                                class="fa fa-undo"></i> Recover</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import practiceSidebar from "../components/Sidebar.vue";
import userAPI from "../../userApi";
import moment from 'moment'

export default {
    name: "view_user",
    components: {
        practiceSidebar
    },
    data() {
        return {
            isLoading: false,
            loginUser: {},
            users: {},
            pastUsers: {},
            focuses: {},
            url: '',
            server_url: '',
            focusMap: {
                'REV': 'Revenue',
                'PV': 'Patient Visits',
                'CPR': 'Care Plan Renewals',
                'NP': 'New Patient',
                'ROF': 'Report of Findings',
            },
            selectedUserId: null,
            idToHide: '',
            selectedFocusNames: []
        }
    },
    methods: {
        proceedAction() {
            if (this.selectedUserId) {
                const selectedFocusNames = this.focuses
                    .filter(focus => focus.FocusName)
                    .map(focus => focus.FocusName);
                const today = new Date();
                const startDate = today.toISOString().split('T')[0];
                const UserID = this.selectedUserId;
                const PracticeID = this.loginUser.PracticeID;
                let completedRequests = 0;
                const messages = [];
                selectedFocusNames.forEach(focus => {
                    userAPI.assignFocuses(
                        { FocusCode: focus, UserID, PracticeID, startDate },
                        (res) => {
                            console.log(res);
                            messages.push(res.data.message);
                            completedRequests++;
                            if (completedRequests === selectedFocusNames.length) {
                                messages.forEach(message => {
                                    this.$showNotification({ message: "Focuses Updated Succesfully" }, "success")
                                });
                            }
                        },
                        (err) => {
                            console.log(err);
                        }
                    );
                });
            } else {
                console.log("No user selected.");
            }
            userAPI.removeUser({ UserID: this.idToHide, PracticeID: this.loginUser.PracticeID }, res => {
                console.log(res.data.message);
                console.log('UserID :', this.UserID);
                this.$bvModal.hide('modal-1');
                this.$showNotification({ message: res.data.message }, "success")
                this.getUsersDashboard();
                this.getPastUsersDashboard();
            }, err => {
                console.log(err);
            })

        },
        preventScreenshot() {
            // Apply CSS to obscure the content
            const css = `
                body {
                    visibility: hidden !important;
                    opacity: 0 !important;
                }
            `;
            const style = document.createElement('style');
            style.appendChild(document.createTextNode(css));
            document.head.appendChild(style);

            // Listen for the beforeunload event and show the content before leaving
            window.addEventListener('beforeunload', function () {
                document.body.style.visibility = 'visible';
                document.body.style.opacity = '1';
            });
        },
        recoverUser(id) {
            this.$swal({
                title: 'Are you sure?',
                text: "Please confirm that you are making this person an active Member of your Team.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, recover it!'
            }).then((result) => {
                if (result.value) {
                    userAPI.recoverUser({ UserID: id }, res => {
                        this.$showNotification({ message: res.data.message }, "success")
                        this.getUsersDashboard();
                        this.getPastUsersDashboard();
                    }, err => {
                        console.log(err);
                    })
                }

            })
        },
        removeUser(id) {
            console.log('id :', id);
            this.idToHide = id;
            this.$swal({
                title: 'Are you sure?',
                text: "Please confirm that this Team Member is no longer with your practice",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, remove this member.'
            }).then((result) => {
                if (result.value) {
                    userAPI.getusersfocus({ UserID: id, PracticeID: this.loginUser.PracticeID }, res => {
                        if (res.data.data == 0) {
                            userAPI.removeUser({ UserID: id, PracticeID: this.loginUser.PracticeID }, res => {
                                console.log('UserID :', this.UserID);
                                this.$showNotification({ message: res.data.message }, "success")
                                this.getUsersDashboard();
                                this.getPastUsersDashboard();
                            }, err => {
                                console.log(err);
                            })
                        } else {
                            console.log(res.data);
                            this.focuses = res.data.data;
                            this.$bvModal.show('modal-1');
                        }
                    }, err => {
                        console.log(err);
                    })
                }
            })
        },

        getUsersDashboard() {
            this.isLoading = true;
            userAPI.getUsersDashboard({ PracticeID: this.loginUser.PracticeID, active: 1 }, res => {
                this.users = res.data.data;
                // Loop through each user and set up the URL
                this.users.forEach(user => {
                    user.url = res.data.server_url + user.Image;
                });
                this.isLoading = false;

            }, err => {
                console.log(err);
                this.isLoading = false;

            })
        },
        viewUser(user) {
            this.$router.push({ name: 'single_user', params: { user: user } })
        },
        editUser(user) {
            this.$router.push({ name: 'edit_dashboard_user', params: { user: user } })
        },
        dateFormat(date) {
            return moment(date).format('MM-DD-Y')
        },
        getPastUsersDashboard() {
            userAPI.getUsersDashboard({ PracticeID: this.loginUser.PracticeID, active: 0 }, res => {
                this.pastUsers = res.data.data;
            }, err => {
                console.log(err);
            })
        }
    },
    mounted() {
        let user = JSON.parse(localStorage.getItem('userDetails'));
        this.loginUser = user;

        if (user.Status == 'DC' || user.Status == 'CA') {
            this.$router.push({ name: 'user_dashboard' });
        }

        this.getUsersDashboard();
        this.getPastUsersDashboard();

        // document.addEventListener('keydown', this.preventScreenshot);
        document.addEventListener('keydown', (event) => {
            if (event.keyCode === 44 && !event.ctrlKey && !event.shiftKey && !event.altKey && !event.metaKey) {
                this.preventScreenshot();
            }
        });
    },
}

</script>
<style>
.swal2-styled {
    padding: 0.625em 1em;
}

.practice {
    user-select: none;
    /* Disable text selection */
}






.radio-group {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    /* Spacing between text and options */
}

.radio-label {
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s, border-color 0.3s;
}

.radio-label input {
    margin-right: 10px;
    /* Space between radio and label text */
}

.radio-label:hover {
    background-color: #f9f9f9;
    /* Light background on hover */
}

.radio-label input:checked+span {
    font-weight: bold;
    /* Bold text for selected option */
}
</style>